import React, { useEffect, useState } from 'react';
import SelectInput from "./SelectInput";
import { getSimpleDurationOptions } from "../../Helpers/DateTimeHelper";

const DurationInput = (props) => {
    const [durationOptions, setDurationOptions] = useState([]);

    useEffect(() => {
        let newDurationOptions = getSimpleDurationOptions(props.maxDuration, props.minDuration, props.minutesStep);
        setDurationOptions( prevState => newDurationOptions );
    }, []);

    return (
        <SelectInput
            name="duration"
            value={props.value}
            options={durationOptions}
            onChange={(e) => props.onChange(props.name, e.target.value)}
            menuPortalTarget={document.body}
            classNamePrefix='modal-select'
        />
    );
}

DurationInput.defaultProps = {
    maxDuration: 1440,
    minDuration: 0,
    minutesStep: 15,
}

export default DurationInput;
